/* eslint-disable react/button-has-type */

import React from "react";
import cx from "classnames";
import { Link, LinkProps } from "react-router-dom";
import styles from "./Button.module.scss";

interface ButtonOurProps {
  className?: string;
  theme?: "primary" | "secondary" | "success" | "danger" | "link";
  size?: "s" | "m" | "l";
  to?: LinkProps["to"];
  replace?: LinkProps["replace"];
}

export type ButtonProps = ButtonOurProps &
  (React.ButtonHTMLAttributes<HTMLButtonElement> & React.AnchorHTMLAttributes<HTMLAnchorElement>);

const Button: React.FC<ButtonProps> = ({
  className,
  children,
  type,
  href,
  to,
  theme = "secondary",
  size = "m",
  ...otherProps
}) => {
  const commonProps = {
    className: cx(
      styles.button,
      className,
      {
        [styles.primary]: theme === "primary",
        [styles.secondary]: theme === "secondary",
        [styles.success]: theme === "success",
        [styles.danger]: theme === "danger",
        [styles.link]: theme === "link",
      },
      {
        [styles.small]: size === "s",
        [styles.medium]: size === "m",
        [styles.large]: size === "l",
      }
    ),
  };
  if (to) {
    return (
      <Link to={to} {...otherProps} {...commonProps}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} {...otherProps} {...commonProps}>
        {children}
      </a>
    );
  }
  return (
    <button type={type || "button"} {...otherProps} {...commonProps}>
      {children}
    </button>
  );
};

export default Button;
